import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  test: {
    marginTop: 15,
  },
  root: {
    marginRight: 10,
    marginLeft: 10,
  },
  gridImage: {
    textAlign: 'center',
    marginBottom: 30,
  },
  image: {
    width: 350,
    float: 'inherit',
  },
  version: {
    textAlign: 'center',
    paddingTop: 20,
  },
}));
